import React, { createRef, Component } from "react";
import {
  Map,
  WMSTileLayer,
  ScaleControl,
  Popup as ReactPopup,
  Marker,
  GeoJSON,
} from "react-leaflet";
import { Button, Popup } from "semantic-ui-react";
import L, { geoJSON } from "leaflet";
import Control from "react-leaflet-control";
//import PieChart from "./GPieChart";
//import ghepanghat from "./Ghepanghatgeojson"

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import {
  faExpand,
  faWindowClose,
  faChartBar,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,
  faChartPie,
} from "@fortawesome/free-solid-svg-icons";
import MouseControl from "../../MousePosition";

import domain from "../../domain";

import { OffCanvas, OffCanvasMenu } from "react-offcanvas";
import { FadeLoader } from "react-spinners";
import { Menu, Message, Icon } from "semantic-ui-react";
import { faTimes } from '@fortawesome/free-solid-svg-icons';


import { isNull } from "util";
import colors from "../../colors";
import urls from "../../urls";
import Chart from "./Chart";
import Axios from "axios";
import { color } from "@mui/system";
import { Opacity } from "@material-ui/icons";
library.add(
  faWindowClose,
  faChartBar,
  faExpand,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,faChartPie,
);

// import Grid9minView from './Grid9minView'
// import DrawPolygon from './DrawPolygon'
// wrap `Dialog` component with `withLeaflet` HOC
// var basicAuth = 'Basic ' + btoa('NhpAdmin' + ':' + 'nhp@1234');
// axios.defaults.headers.common['Authorization']=basicAuth

const crs = L.CRS.EPSG4326;

// const PrintControl = withLeaflet(PrintControlDefault);

var label = {};

//var spinner = new Spinner().spin();

let count = 0;
let count1 = 0;
// const style = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
let numMapClicks = 0;

class GMapView extends Component {

  constructor(props) {
    super(props);
    this.geoJsonLayerRef = React.createRef(); 
    this.markerGroup = L.layerGroup();
       this.state = {
      
      minZoom: 3,
      zoom: window.innerWidth > 1000 ? 5 : 3,
      position: null,
      layers: urls.glof_layer,
      url: urls.glof_url,
      popup: {
        key_p: 0,
        position: null,
      },
      baseLayers: false,
      baselayerselected: "Shaded Relief",
      //center: [44.12539, 82.00164],
      center: window.innerWidth > 1000 ? [28.12539, 82.00164] : [20.13, 80.58],
      latlng: { lat: null, lng: null },
      pointInfo: null,
      maxZoom: 50,
      isMenuOpened: true,
      wms_url_default: `${domain.Geoserver}/nhp_snowcomponent/wms`,
      wms_url_cgl: `${domain.Geoserver}/nhp_glacial_cgl/wms`,
      legend: null,
      legendVisible: true,
      visibleRight: false,
      isExpand: false,
      showInfo: true,
      geoJSONMinZoom:10,
      geoJSONMaxZoom:20,
     
      // loading:false,
      forecast: false,
      layerloading: false,
      stateInfoStatus: false,
      labelMarkers: [],
      gl_info:null,
      
      geoJsonLayer : null,
      isMessageVisible:true,
      currentZoom: null,
      layerErrors:{},
    };
    ///let markerLayerGroup = L.layerGroup();
  }
  
  mapRef = createRef();
  tileRef = createRef();
  closeTab = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };

  loading = (e) => {
    this.setState({
      layerloading: true,
    });
    // console.log(e)
  };


  displayBaseLayers = () => {
    console.log("base layers");
    this.setState({
      baseLayers: !this.state.baseLayers,
    });
  };

  handleTileError = (value) => {
    console.log("errorrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
 let factor=value;
    // Avoid updating the state if the error for this factor is already set
    if (!this.state.layerErrors[factor]) {
      this.setState((prevState) => ({
        layerErrors: {
          ...prevState.layerErrors,
          [factor]: true,
        },
      }), () => {
        // Show alert only after state update, but avoid multiple alerts
        window.alert(`The layer for factor ${factor} is not available.`);
      });
    }
  };

  handleMapZoom = (newZoom) => {
    this.setState({ currentZoom: newZoom });
  };
  closeMessage = () => {
    // Add the code to close the message box here
    // You may need to update the state to hide the message box
    this.setState((prevState) => ({ isMessageVisible: !prevState.isMessageVisible }));
  };
 capitalizeFirstLetter=(string)=> {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  changeBaseLayer = (event) => {
    let layers, url;
    //  this.findActiveLayers()
    console.log(event.target);
    if (event.target.value === "Map") {
      url = urls.bhuvan_map;
      layers = urls.map_layer;
    } else if (event.target.value === "Satellite") {
      layers = urls.s_layer;
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = urls.satellite;
    } else if (event.target.value === "Shaded Relief") {
      layers = "nhp_snowcomponent:DEM";
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = this.state.wms_url_default;
    } else if (event.target.value === "River") {
      layers = "nhp_snowcomponent:snow_river";
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = this.state.wms_url_default;
    }

    this.setState({
      baselayerselected: event.target.value,
      url: url,
      layers: layers,
    });
  };
  onload = (e) => {
    this.setState({
      layerloading: false,
    });
  };

  resetZoom = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    // leafletMap.setMaxBounds(leafletMap.getBounds());

    // leafletMap.fitBounds()
    leafletMap.setZoom(this.state.zoom);
    //leafletMap.panTo(new L.LatLng(29.12539, 84.00164))
  };

  displayLegend = () => {
    this.setState({ legendVisible: !this.state.legendVisible });
  };

  showInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };
  showInfo_gl = () => {

    console.log("stateInfo",this.state.gllakeInfoStatus,this.props.boundary)
    this.setState( {stateInfoStatus:true,

    

    });

  };
  onMouseOver = (e) => {
    console.log(e.latlng,"latlng");
    this.props.setLatLng(e.latlng);
    this.props.setStateInfoStatus();
    
    this.setState({
     // position:e.latlng,
      //minZoom:100,
     // maxZoom:100,
    })


    
    //  console.log(e)
    // this.props.setLatLng({lat: L.Projection.LonLat.project(e.latlng).y, lng:L.Projection.LonLat.project(e.latlng).x})

    Axios.get(
      `${domain.DBServer}/get-glof-basininfoglacial/${e.latlng.lng}/${e.latlng.lat}`
    ).then((result) => {
      console.log(result);
      if (result) {
        if (result.data) {
          this.props.setStateInfo(result.data[0]);
        } else {
          this.props.setStateInfo(null);
        }
      }
    });

    
    Axios.get(
      `${domain.DBServer}/get-GL-Lake-boundary/${e.latlng.lng}/${e.latlng.lat}`
    ).then((result) => {
      console.log(result);
      if (result) {
        if (result.data) {
          this.props.setGLLakeBoundary(result.data[0].boundary);
          this.setState({
            //boundary:info,
            stateInfoStatus:true,
            visibleGraphPanel_pie:false,
            visibleGraphPanel_pie1:false,


            series: null,
            series_gl_type: null,

            //gllakeInfoStatus: false,
            
      
          })
        } else {
          this.props.setGLLakeBoundary(null);
        }
      }
    });


  };
 
  componentDidUpdate(prevProps, PrevState) {
    // if(this.props.visibleLeft===false){
    //     const leafletMap = this.mapRef.current.leafletElement
    //     leafletMap.invalidateSize()
    // }
    // if(this.props.visibleGraphPanel===false){
    //     const leafletMap = this.mapRef.current.leafletElement
    //     leafletMap.invalidateSize()
    // } this.getLegendGraphic(wms_url, layer).then((legend) => {
      if (this.props.gl_lake_boundary !== prevProps.gl_lake_boundary) {
        const geoJsonLayer = this.geoJsonLayerRef.current;
       
    
        if (geoJsonLayer) {
          geoJsonLayer.leafletElement.clearLayers(); // Clear old features
          geoJsonLayer.leafletElement.addData(this.props.gl_lake_boundary); // Add new data
        }
      }
      
   
    
  }
  componentDidMount() {
    this.getLegendGraphic(this.state.wms_url_default, 'nhp_glacials:ihr_gl_wb').then((legend) => {

      this.setState({
        legend: legend
      })
    })
  }
  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 20;

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14`;

    return img_src;
  }

  handleAnimationChangeRight = () => {
    this.setState({
      visibleRight: !this.state.visibleRight,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };
  handleExpand = () => {
    this.setState({
      isExpand: !this.state.isExpand,
    });
  };

  highlightHimalayan = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    layer.setStyle({
      weight: 3,
      fill:false, 
      //color: "#000000",
      //fillOpacity: 0
    });
    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
     //  maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
    console.log(window.innerHeight, window.innerWidth);
    map.panTo([29.3333, 86.923], 8);
  };

  highlightBasinRiverSub = (feature, layer) => {
    console.log(layer,"subbbbbbbbbbbbbbbbbb");

    const map = this.mapRef.current.leafletElement;

    layer.setStyle({
      weight: 2,
      fill: false,
     // color: "#009933",
     //color:' #dbd55e',
      // fillOpacity: 0
    });
    // layer.bindPopup('hello');
    this.setState({
      popup: {
        position: null,
      },
    });
   

    let string =
      typeof feature.properties.subbasin !== "undefined"
        ? feature.properties.subbasin
        : feature.properties.basin;
    if (label !== undefined) {
      map.removeLayer(label);
    }
    if (string===undefined)
    {
      string=""
      console.log("this.props.gllakeInfoStatus===null",this.props.gllakeInfoStatus)
      if(this.props.gl_lake_boundary)
      {string=""}
    
 
    }
    label = L.marker(layer.getBounds().getCenter(), {
      icon: L.divIcon({
        className: "label",
        
        html: `<h1>${string}</h1>`,
        iconSize: [100, 40],
      }),
    }).addTo(map);
    //         map.showLabel(label);
    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
      // maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };


  highlightCGLInundationLake = (feature, layer) => {
    
    const map = this.mapRef.current.leafletElement;

    console.log(feature,"RRRRRRRRRRRRRRRRRRRRRRRRRRR",layer)
    console.log(map);
    layer.setStyle({
      color: 'transparent', // Set color to transparent
      weight: 0,  
      fill:false,

      fillOpacity: 0,
      
    });
    

    //map.fitBounds(layer.getBounds(),{ maxZoom: 25})
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
       maxZoom:35// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  
  };
  highlightCGLInundationBasin = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    console.log(feature)
    console.log(map);
    layer.setStyle({
      weight: 2,
      color: "blue",
      fill:false,

      fillOpacity: 0,
    });

    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
      // maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  
};






  highlightGLLake = (feature, layer) => {

    const map = this.mapRef.current.leafletElement;

    console.log(layer,feature,"layerrrrrrrrr")


    layer.setStyle({
      weight: 2,
     // fillColor: 'blue',
     fill:false,

      fillOpacity: 0,
    });
    
    let string =
      typeof feature.properties.subbasin !== 'undefined'
        ? feature.properties.subbasin
        : feature.properties.basin;
  
    if (string !== undefined) {
      L.marker(layer.getBounds().getCenter(), {
        icon: L.divIcon({
          className: 'label',
          html: `<h6>${string}</h6>`,
          iconSize: [100, 40],

        }),
      }).addTo(map);
    }
   // map.fitBounds(layer.getBounds(),{ maxZoom: 12 }); // This line will zoom the map to the bounds of the layer.
   
   map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, 
     maxZoom:12// Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });

  
  };
   
  highlightCritical = (feature, layer) => {

    const map = this.mapRef.current.leafletElement;

    console.log(layer,feature,"layerrrrrrrrr")


    layer.setStyle({
      weight: 2,
     // fillColor: 'blue',
     fill:false,

      fillOpacity: 0,
    });
    //markerGroup.clearLayers();
    let string =
      typeof feature.properties.subbasin !== 'undefined'
        ? feature.properties.subbasin
        : feature.properties.basin;
  console.log(string,"string")
    if (string !== undefined) {
     this.markerGroup.addLayer( L.marker(layer.getBounds().getCenter(), {
        icon: L.divIcon({
          className: 'label',
          html: `${string}`,
          iconSize: [100, 40],

        }),
      }))
     //map.fitBounds(layer.getBounds(),{ maxZoom: 6 });
     
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
       maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
    }
    //map.fitBounds(layer.getBounds()); // This line will zoom the map to the bounds of the layer.
  
  };
  highlightCriticalall = (feature, layer) => {
      // const map = this.mapRef.current.leafletElement
      const map = this.mapRef.current.leafletElement;
      layer.setStyle({
        weight: 2,
       // color: "blue",
        fillOpacity: 0,
         fill:"blue"

      });
  
    }
  
  clearMarkers = () => {
    this.markerGroup.clearLayers();
  };
  
  addPopup = (e) => {
    this.setState({
      popup: {
        key: numMapClicks++,
        position: e.latlng,
      },
    });

    //   console.log(e.target)
  };

  highlightBasin = (feature, layer) => {
    //    console.log(layer)
    // const map = this.mapRef.current.leafletElement
    layer.setStyle({
      weight: 2,
     // color: "	#808080",
      fillOpacity: 0,
      fill:false,

    });
    // var mini=new L.Control.MiniMap(layer, { toggleDisplay: true });
    // map.addControl(mini)
    // layer.on({
    //     mouseover:
    // })
    layer.on({
      click: this.addPopup,
    });
    // map.fitBounds(layer.getBounds());
  };
  handleMarkerMouseOver = (e) => {
    // Handle mouseover event on the marker
    console.log('Mouse over marker at:', e.latlng);
   // this.onMouseOver(e)

  };


 

  componentWillUpdate() {
    if (this.props.visibleLeft === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel1 === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
  }
  highlightState = (feature, layer) => {
    // const map = this.mapRef.current.leafletElement
    const map = this.mapRef.current.leafletElement;
    layer.setStyle({
      weight: 2,
      color: "#000000",
      fillOpacity: 0,
      fill:false
    });

    layer.on({
      mouseover: (event) => {
        layer.setStyle({
          weight: 3,
          color: "#0000ff",
          fillOpacity: 0,
          //  fill:false
        });
      },
      mouseout: (event) => {
        layer.setStyle({
          weight: 3,
          color: "#000000",
          fillOpacity: 0,
          //  fill:false
        });
      },
    });
    //   let string = feature.properties.state!==null?feature.properties.state:""
    // let  label = L.marker(layer.getBounds().getCenter(), {
    //     icon: L.divIcon({
    //       className: "label",
    //       html: `<h5>${string}</h5>`,
    //       iconSize: [20, 20],
    //     }),
    //   }).addTo(map);
  };
  render() {

    console.log("ssssssssssssinundation",this.props.InudationLakeSimBoundary)
    console.log("sssssglofriskselected",this.props.glofriskassesmentselected,this.props.criticalglaciallakeselected,this.props.critical_glacial_lake_boundaryall)
      console.log("this.props.selectedFactorrrrrrrrrrs",this.props.selectedFactors,this.props.selectedFeatures)
    console.log("listtttttttttttttttttttt",this.props.criticalInudationBasinboundary,this.props.boundary,this.props.categories_cgl,this.props.series_cgl,this.props.glofriskassesmentselected,this.props.criticalfeatureSelected,this.props.criticalIndSimBasinSelected,this.props.criticalIndSimLakeSelected,
    this.props.categories_gl_type_cgl,this.props.series_gl_type_cgl,this.props.critical_glacial_lake_boundary,this.props.critical_glacial_lake_boundaryall,this.props.glofriskinundation,this.props.criticalglaciallakeselected,
    this.props.criticalRiskBasinSelected,this.props.criticalRiskLakeSelected,this.props.criticalIndSimScenarioSelected, this.props.criticalIndSimScenarioSelectedRisk, this.props.critical_gl_lake_boundary_status,this.props.criticalFactorSelected,this.props.legend_SimScenario
    
  )
  console.log("selected features ,factors ", this.props.selectedFactors,this.props.selectedFeatures)  

   if (this.props.himalayan_boundary) {
      count1 = count1 + 1;
    }

    if (this.props.geojsonadd) {
      count = count + 1;
    }
    console.log(this.props.geojsonadd, count);
    console.log(this.props.selectedLayer);
    console.log(this.state.layerloading);
    delete L.Icon.Default.prototype._getIconUrl;
    console.log(this.props.critical_glacial_lake_boundary,"cri_g_l)")

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });

    return (
      <Map
        ref={this.mapRef}
        // ref={m => { this.leafletMap = m }}
        center={this.state.center}
        minZoom={this.state.minZoom}
        maxZoom={this.state.maxZoom}
        zoom={this.state.zoom}


       
        //onMouseOver={this.handleMarkerMouseOver}//{this.onMouseOver} // Change this line
        onClick={this.onMouseOver}
        // onlayeradd={this.onLayer}
        style={{ backgroundColor: "#fff" }}
        attributionControl={false}
        
        crs={crs}
        dragging={true}
      >
        {this.props.india_states_boundary !== null ?

          <GeoJSON
            ref="geojson"
            key={this.props.india_states_boundary.features[0].id}
            data={this.props.india_states_boundary}
            onEachFeature={this.highlightState}

          />
          : null}

     



        {/* {
                        this.props.selected!==null ?
       
                            <WMSTileLayer
                                url={`${domain.Geoserver}/nhp_glacials/wms`}
                                layers= {"nhp_glacials" + ":" + this.props.selected.toLowerCase().split(' ').join('-')}
                                format= 'image/png'
                                zIndex={10}
                                transparent= {true}
                                onloading={this.loading}
                                onload={this.load}
                                tiled={false}
                                // opacity={1}
                                // crs={ crs}
                            />
                            
                        :null
                         
                    } */}

        {/* {
                   this.props.glacial_lakes!==null && this.props.selected==='Glacial Lakes'?
                      <GeoJSON 
                        ref="geojson" 
                        key={count+1} 
                        data={this.props.glacial_lakes}
                        onEachFeature={this.highlightBasin}
                        // crs={crs}
                        // zIndex={10}
                        // transparent={true}
                        onloading={this.loading}
                        onload={this.onload}
                    />:null
                    

                    } */}

        {/* {this.props.himalayan_boundary ? (
          <GeoJSON
            ref="geojson"
             key={this.props.himalayan_boundary.features[0].id}
            data={this.props.himalayan_boundary}
            onEachFeature={this.highlightHimalayan}
          // crs={ crs}
          />
        ) : null} */}

{this.props.glofriskassesmentselected!=="cgl"   ? (
        this.props.boundary!==null? (
          <GeoJSON
            ref="geojson_1"
            key={this.props.boundary.features[0].id}
            data={this.props.boundary}
            onEachFeature={this.highlightBasinRiverSub}
          
          // crs={ crs}
          />
        ) : null
):null}
{this.props.glofriskassesmentselected==="cgl"&& this.props.collapsed===false  &&this.props.criticalglaciallakeselected==="cgl_all" && this.props.glofriskassesmentselected!=="gis" ? (
        this.props.boundary!==null? (
          <GeoJSON
            ref="geojson_1"
            key={this.props.boundary.features[0].id}
            data={this.props.boundary}
            onEachFeature={this.highlightBasinRiverSub}
          
          // crs={ crs}
          />
        ) : null
):null}
         {this.props.gl_lake_boundary!==null? (
          <GeoJSON
            ref="geojson_1"
            key={this.props.gl_lake_boundary.features[0].id}
            data={this.props.gl_lake_boundary}
            onEachFeature={this.highlightGLLake}
           

          // crs={ crs}
          />
        ) : null}
        {this.props.glofriskassesmentselected!=="cgl"  && this.props.criticalIndSimBasinSelected!=="#"&& this.props.collapsed===false  && this.props.glofriskassesmentselected==='gis' ? (
        this.props.criticalInudationBasinboundary!==null? (
          <GeoJSON
            ref="geojson"
            key={this.props.criticalInudationBasinboundary.features[0].id}
            data={this.props.criticalInudationBasinboundary}
           style={{fillOpacity:0}}
           onEachFeature={this.highlightCGLInundationBasin}
           
          // crs={ crs}
          />
        ) : null
):null}
{this.props.glofriskassesmentselected!=="cgl"  && this.props.criticalRiskBasinSelected!=="#" && this.props.collapsed===false && this.props.glofriskassesmentselected==="gr" ? (
        this.props.criticalRiskBasinboundary!==null? (
          <GeoJSON
            ref="geojson"
            key={this.props.criticalRiskBasinboundary.features[0].id}
            data={this.props.criticalRiskBasinboundary}
           style={{fillOpacity:0}}
           onEachFeature={this.highlightCGLInundationBasin}
           
          // crs={ crs}
          />
        ) : null
):null}

{this.props.glofriskassesmentselected!=="cgl" && this.props.collapsed===false && this.props.criticalIndSimLakeSelected!=='#'? (
        this.props.InudationLakeSimBoundary!==null? (
          <GeoJSON
            ref="geojson"
            key={this.props.InudationLakeSimBoundary.features[0].id}
            data={this.props.InudationLakeSimBoundary}
            style={{fillOpacity:0}}
            onEachFeature={this.highlightCGLInundationLake}
          // crs={ crs}
          />
        ) : null
):null}
{this.props.glofriskassesmentselected!=="cgl" && this.props.collapsed===false && this.props.criticalRiskLakeSelected!=="#" ? (
        this.props.glofRiskLakeBoundary!==null? (
          <GeoJSON
            ref="geojson"
            key={this.props.glofRiskLakeBoundary.features[0].id}
            data={this.props.glofRiskLakeBoundary}
            style={{fillOpacity:0}}
            onEachFeature={this.highlightCGLInundationLake}
          // crs={ crs}
          />
        ) : null
):null}
        
        
         
         
     {
    this.props.critical_glacial_lake_boundary!==null&& this.props.collapsed===false  && this.props.criticalglaciallakeselected!=="cgl_all"? (
      this.props.critical_glacial_lake_boundary !==null? (
     
    <GeoJSON   ref="geojson_1"
     key={this.props.critical_glacial_lake_boundary.features[0].id}
    data={this.props.critical_glacial_lake_boundary} 
      style={ {      fill:false,

        fillOpacity: 0}} 
        minZoom={this.state.geoJSONMinZoom}
        maxZoom={this.geoJSONMaxZoom} 
        onEachFeature={this.highlightCritical}
       />
      ):null
        
     ):null}

     {/*
    this.props.critical_glacial_lake_boundaryall!==null&& this.props.collapsed===false  && 
    this.props.glofriskassesmentselected==='cgl' && this.props.glofriskassesmentselected!=="gis"? (
      this.props.critical_glacial_lake_boundaryall!==null?(
        console.log("aaaaaaaaaaaaasssssssssss", this.props.critical_glacial_lake_boundaryall),

     
    <GeoJSON   ref="geojson_1"
     key={this.props.critical_glacial_lake_boundaryall.features[0].id}
    data={this.props.critical_glacial_lake_boundaryall} 
      style={ {      fill:false,

        fillOpacity: 0}} 
        minZoom={this.state.geoJSONMinZoom}
        maxZoom={this.geoJSONMaxZoom} 
        onEachFeature={this.highlightCriticalall}
      
       />
    ):null
        
     ):null*/}


{this.props.criticalglaciallakeselected==="cgl_all" && this.props.collapsed===false  ? (
      this.props.critical_glacial_lake_boundaryall!==null ?(
        console.log("aaaaaaaaaaaaassssssssssssdddddddddd", this.props.critical_glacial_lake_boundaryall),
     
      <GeoJSON   ref="geojson_1"
       //key={this.props.critical_glacial_lake_boundaryall.features[0].id}
      data={this.props.critical_glacial_lake_boundaryall} 
        style={ {      fill:"blue",

          fillOpacity: 0}} 
          minZoom={this.state.geoJSONMinZoom}
          maxZoom={this.geoJSONMaxZoom} 
          onEachFeature={this.highlightCriticalall}
        
         />
      ):null
          
       ):null}
       
{this.props.selectedFactors.length !== 0  && (this.props.criticalIndSimLakeSelected!=='#'||this.criticalRiskLakeSelected!=='#' )&& (
  this.props.selectedFactors.map(factor => (
    <WMSTileLayer
      url={`${domain.Geoserver}/nhp_glacial_cgl/wms`}
      layers={`nhp_glacial_cgl:${factor}`} // Use backticks for template string
      format="image/png"
      zIndex={14}
      transparent={true}
      onLoading={this.loading} // Use onLoading instead of onloading
      onLoad={this.load} // Use onLoad instead of onload
      tiled={false}
     // onTileError={this.handleTileError(factor)}

    />
  ))
)}
{this.props.selectedFeatures.length !== 0 && this.props.criticalIndSimBasinSelected!=='#'&&this.props.criticalIndSimLakeSelected!=='#'&& (
  this.props.selectedFeatures.map(feature => (
    <WMSTileLayer
      url={`${domain.Geoserver}/nhp_glacial_cgl/wms`}
      layers={`nhp_glacial_cgl:${feature}`} // Use backticks for template string
      format="image/png"
      zIndex={13}
      transparent={true}
      onLoading={this.loading} // Use onLoading instead of onloading
      onLoad={this.load} // Use onLoad instead of onload
      tiled={false}
      //onTileError={this.handleTileError(feature)}
      //onTileError={() => window.alert('The layer is not available.')}
      // onError={() => window.alert('The layer is not available.')}

    />
    
  ))
  
)}
        {this.props.layerselected !== null &&  this.props.collapsed2===false  ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_glof_glacial_lakes/wms`}
           // layers="nhp_glacials:ihr_gl_wb"
            layers="nhp_glof_glacial_lakes:glof_glacial_lakes_may2023"

            format="image/png"
            zIndex={10}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
            tiled={false}
          />
        ) : null}
         {this.props.glofriskassesmentselected==='gr'&& this.props.criticalRiskBasinSelected!=='#'&&this.props.criticalRiskLakeSelected!=="#" && this.props.collapsed===false ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_glacial_cgl/wms`}
           // layers="nhp_glacials:ihr_gl_wb"
            layers={`nhp_glacial_cgl:${this.props.criticalRiskLakeSelected+"_"+this.props.criticalIndSimScenarioSelectedRisk}`}

            format="image/png"
            zIndex={12}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
            tiled={false}
          />
        ) : null}
        

        {this.props.glofriskassesmentselected==='cgl'  ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_glacial_cgl/wms`}
           // layers="nhp_glacials:ihr_gl_wb"
            layers="nhp_glacial_cgl:Indus_Ganga_Brahamaputra_CGL_25"

            format="image/png"
            zIndex={11}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
            tiled={false}
          />
        ) : null}
        
         {this.props.glofriskassesmentselected==='gis'|| this.props.glofriskassesmentselected==='gr'  ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_glacial_cgl/wms`}
           //layers="nhp_glacials:ihr_gl_wb"
            layers="nhp_glacial_cgl:srtm_ihr_30m_acea_hillshade_2023"

            format="image/png"
            zIndex={11}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
            tiled={false}
           
         />
        ) : null}
        
        {this.state.baselayerselected !== null ? (
          <WMSTileLayer
            ref={this.tileRef}
            layers={this.state.layers}
            // url='http://192.168.192.103:8080/geoserver/cite/wms'
            url={this.state.url}
            format="image/png"
            transparent={true}
            // crs={ crs}
            zIndex={1}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}
        {/* <LayersControl position="topright" autoZIndex={false}>
                   
                   
                    <BaseLayer name="Map" checked >
                        <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'india3'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url='https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms'
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    zIndex={9}
                                   
                                    onloading={this.loading}
                                     onload={this.onload}
                                    // onload={this.load}
                                    // opacity={1}
                            />

                      </BaseLayer>
                      <BaseLayer name="Satellite" >
                            <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'bhuvan_imagery'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url='https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py'
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    zIndex={1}
                                    onloading={this.loading}
                                    onload={this.load}
                                    
                            />
                        </BaseLayer>

                        <BaseLayer name="DEM" >
                        <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'nhp_snowcomponent:DEM'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url={`${domain.Geoserver}/nhp_snowcomponent/wms`}
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    zIndex={10}
                                    onloading={this.loading}
                                    onload={this.onload}
                                   
                            />
                        </BaseLayer>
                        <BaseLayer name="LULC"  >
                        <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'nhp_snowcomponent:glacial_LULC'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url={`${domain.Geoserver}/nhp_snowcomponent/wms`}
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    zIndex={9}
                                 
                                    onloading={this.loading}
                                    onload={this.onload}
                            />
                    </BaseLayer>
                     
             
                    
                    </LayersControl> */}

        <Control position="topright">
          <OffCanvas
            width={180}
            transitionDuration={300}
            effect={"overlay"}
            style={{ cursor: "move" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <OffCanvasMenu
              style={{
                alignContent: "center",
                backgroundColor: "rgb(255,255,255)",
                borderColor: "blue",
                top: "50px",
                marginRight: "10px",
              }}
            >
              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.displayBaseLayers}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Base Layers
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.state.baseLayers ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                          <FontAwesomeIcon icon="angle-right" />
                        )}
                    </div>
                  </div>
                </Menu.Item>
              </div>
              {this.state.baseLayers ? (
                <div>
                  <input
                    type="radio"
                    name="baselayer"
                    value="Satellite"
                    checked={this.state.baselayerselected === "Satellite"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Satellite <br />
                  <input
                    type="radio"
                    name="baselayer"
                    value="Map"
                    checked={this.state.baselayerselected === "Map"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Map <br />
                  <input
                    type="radio"
                    name="baselayer"
                    value="Shaded Relief"
                    checked={this.state.baselayerselected === "Shaded Relief"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Shaded Relief <br />
                  <input
                    type="radio"
                    name="baselayer"
                    value="River"
                    checked={this.state.baselayerselected === "River"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  River <br />
                </div>
              ) : null}

              <div></div>
              <div style={{ background: colors["final_side"] }}>
                {/* <Menu.Item
                  as="div"
                  onClick={this.displayCutoff}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: "gray",
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Cut Off
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.state.cutoff ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                          <FontAwesomeIcon icon="angle-right" />
                        )}
                    </div>
                  </div>
                </Menu.Item> */}
              </div>
              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.displayLegend}
                  style={{
                    textAlign: "center",
                    marginLeft: `5px`,
                    cursor: "pointer",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                      }}
                    >
                      Legend
                      </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.state.legendVisible ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                          <FontAwesomeIcon icon="angle-right" />
                        )}
                    </div>
                  </div>
                </Menu.Item>
              </div>
              {(this.state.legendVisible && this.props.glofriskassesmentselected==='cgl' )?(

                <React.Fragment>
                  <left >
                    Selected Glacial Point
                  <span className="legend-circle" style={{ backgroundColor: "red", border:"2px solid black",borderRadius: "50%", width: "10px", height: "10px", display: "inline-block"}}></span>


                  </left>
                  </React.Fragment>
                 ):null}



              {(this.state.legendVisible && this.props.collapsed===true)?(
                <React.Fragment>
                  <left >

                    Glacial Lake

                    <img src={this.state.legend} alt='' />

                     <br/>
                     </left>
                     </React.Fragment>
                     ):null}

                   
              {(this.state.legendVisible && this.props.collapsed===false)?(
                <React.Fragment>
                  {/* <left style={{  backgroundColor:colors.final_side_inner}} >   */}

                  <left >  
                  Selected Glacial Lake: 
                  <span className="legend-color" style={{ backgroundColor: "#0021f3",border:"2px solid #3388ff"}}></span>
                {this.props.legend_SimScenario!==null ?(
                  <> 
              <span style={{ marginRight: '5px' ,fontSize:"12px", textTransform: 'capitalize'}}>{this.props.legend_SimScenario.match(/[a-zA-Z]+/)[0]+" zones" } </span>  <span >    </span>

            <img 
    src={`${this.state.wms_url_cgl}?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&STRICT=false&style=nhp_glacial_cgl:${this.props.legend_SimScenario}&format=image/png&width=10&height=10&dx:0.2;dy:0.2;mx:0.2;my:0.2`}

   //src={`   https://bhuvan.nrsc.gov.in/nhpgs/nhp_glacial_cgl/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&STRICT=false&style=nhp_glacial_cgl:${this.props.legend_SimScenario}&format=image/png&width=10&height=10&dx:0.2;dy:0.2;mx:0.2;my:0.2`}
    alt={this.props.legend_SimScenario} 
    style={{ verticalAlign: 'right' ,marginRight:"-60px"}} // Adjust width and height

  />

   
   </>
):null}
                
{
  this.props.selectedFactors.length !== 0 ? (
    this.props.selectedFactors.map(factor => {

      console.log("factorrrrrrrrrrrr",factor)
      if (factor.split('_').slice(1).join('_') !== "Settlement_Names" ) {
        if(factor.split('_').slice(1).join('_')!=="settlement_points"){
        return (
          <div key={factor.split('_').slice(1).join('_')} style={{ marginBottom: '10px',marginLeft:'5px' }}> {/* Adjust margin bottom */}
            <span style={{ marginRight: '5px', fontSize: "13px", textTransform: 'capitalize' }}>{factor.split('_').slice(1).join('_')==="agriculture"?"agricultural Land":factor.split('_').slice(1).join('_')==="settlement_polygon"?"settlements":factor.split('_').slice(1).join('_')}</span> {/* Adjust margin right */}
            <img
              key={factor.split('_').slice(1).join('_')}
              src={`${this.state.wms_url_cgl}?request=GetLegendGraphic&layer=nhp_glacial_cgl:${factor}&format=image/png&width=10&height=10&dx:0.2;dy:0.2;mx:0.2;my:0.2`}
              alt={`${factor}`}
              style={{ verticalAlign: 'right', width: '15px', height: '15px' }} // Adjust width and height
            />
          </div>
        );
     } } else {
        return null; // Skip rendering for "Settlement_Names"
      }
    })
  ) : null
  

}




{this.props.selectedFeatures.length !== 0 ? (
  this.props.selectedFeatures.map(feature => {
    let label = '';
    let unit = '';
    let showLegend = true;
    let inundation1=false;
    console.log("featuresssssssssssssssssssssssss",feature,feature.split("_")[3])

    if (feature.includes("velocity")) {
      inundation1=false;
      label = this.capitalizeFirstLetter("velocity");
      unit = "m/s";
    } else if (feature.includes("depth")) {
      inundation1=false;
      label = this.capitalizeFirstLetter("depth");
      unit = "m";
    }
    else if (feature.includes("inundation")) {
      inundation1=true;
      showLegend = true;

      label = this.capitalizeFirstLetter("inundation");
      
    }

    return (
      <div key={feature} style={{ marginBottom: '10px' }}>
        <span style={{ marginLeft: '5px', fontSize: "13px" }}>
          {showLegend && !inundation1? `${label} (${unit})` : ""}

          {showLegend && inundation1? `${label}` : ""}

        </span>

        {showLegend && !inundation1 &&(
          <img
            key={feature}
          src={`${this.state.wms_url_cgl}?request=GetLegendGraphic&layer=nhp_glacial_cgl:${feature}&format=image/png&width=10&height=10&dx:0.2;dy:0.2;mx:0.2;my:0.2`}
          alt={feature}
          
          style={{ verticalAlign: 'right', marginRight: "-45px" }}
        />
        )}
        {showLegend && inundation1 &&(
          <img
            key={feature}
          src={`${this.state.wms_url_cgl}?request=GetLegendGraphic&layer=nhp_glacial_cgl:${feature}&format=image/png&width=10&height=10&dx:0.2;dy:0.2;mx:0.2;my:0.2`}
          alt={feature}

          
          style={{ verticalAlign: 'right', marginRight: "-35px" ,height:"15px"}}
        />
        )}
      </div>
    );
  })
) : null}
                   
                    <br/>
                    
                     
                    
                  </left>
                </React.Fragment>
              ) : null}
            
              </OffCanvasMenu>
              </OffCanvas>
              </Control>


            {(this.props.glofriskassesmentselected !== "gr" && this.props.glofriskassesmentselected !=='gis') &&(
 <Control position="topleft">
            
 <OffCanvas
   width={300}
   transitionDuration={300}
   effect={"overlay"}
   style={{ cursor: "move" }}
   isMenuOpened={this.state.isMenuOpened}
   position={"left"}
 >
   <OffCanvasMenu
     style={{
       alignContent: "center",
       //backgroundColor: "rgb(255,255,255)",
       backgroundColor: "#f2f2f2",
       borderColor: "blue",
       top: "200px",
       marginRight: "10px",
     }}

   >




 <div>  
{this.props.latlng !== null ? (
 <div
   style={{
     marginRight: "0px",
     paddingLeft: "0rem",
     paddingRight: "0rem",
     marginLeft: "0px",
     backgroundColor: "#f2f2f2",
   }}
 >
   
   <Message
     warning={isNull(this.props.pointInfo)}
     attached="bottom"
     color={isNull(this.props.pointInfo) ? "#f2f2f2" : "#f2f2f2"}
   >
                                  
     {this.props.stateInfoStatus ? (
        <FadeLoader
        
         loading={this.props.stateInfoStatus}
       />
     ) : this.props.stateInfo !== null &&this.props.isInfoOpen ?(
       <Message.Content 
       
       
         style={{ zIndex: "50 !important", backgroundColor: "#f2f2f2", color: colors.final_footer }}
       > 
       <div >

       
      <h6 style={{fontWeight:'bold',textAlign:'center',color:colors.text_sub_color}}>Glacial Lake Details  </h6>
       
           <table class='table table-bordered table-sm'  style={{ background: "#f2f2f2" ,color: colors.text_sub_color,font :5}}> <tr>
             <td>

             <span style={{fontWeight: 'bold'}}>ID &nbsp;</span>
               </td> 
             <td>
               {this.props.stateInfo.id !== null ? (
                 <b> <span style={{fontWeight: 'bold'}}>

                   {this.props.stateInfo.id
                     
                     .split(" ")
                     .map((word) =>
                       word.replace(word[0], word[0].toUpperCase())
                     )
                     .join(" ")}</span>
                 </b>
               ) : null}</td></tr><tr>
               <td>

                 <b>River System </b>&nbsp;</td>
               <td>
                 {this.props.stateInfo.river
                   .toLowerCase()
                   .split(" ")
                   .map((word) =>
                     word.replace(word[0], word[0].toUpperCase())
                   )
                   .join(" ")}
               </td></tr><tr><td>
                 <b>Basin</b>&nbsp;</td><td>
                 {this.props.stateInfo.basin
                   .toLowerCase()
                   .split(" ")
                   .map((word) =>
                     word.replace(word[0], word[0].toUpperCase())
                   )
                   .join(" ")}
               </td></tr><tr><td>
                 <b>Sub Basin</b>&nbsp;</td>
               <td>{this.props.stateInfo.subbasin
                 .toLowerCase()
                 .split(" ")
                 .map((word) =>
                   word.replace(word[0], word[0].toUpperCase())
                 )
                 .join(" ")}
               </td></tr>
             <tr>
               <td>
                 <b>Area</b>&nbsp;{" "}</td><td>
                 {Number(this.props.stateInfo.area).toLocaleString("en-IN") +
                   " ha"}
               </td>
             </tr>
              <tr>
                 <td>
               <b>Latitude</b>&nbsp;{" "}</td><td>
               {Number(this.props.stateInfo.latitude).toFixed(2)}
                 
                 </td>
                 </tr>
                 <tr>
                 <td>
               <b>Longitude</b>&nbsp;{" "}</td><td>
               {Number(this.props.stateInfo.longitude).toFixed(2)}
                 
                 </td>
                 </tr> 
             <tr>
               <td>
                 <b>Elevation</b>&nbsp;{" "}</td><td>
                 {Number(this.props.stateInfo.elev) + ' m'}

               </td>
             </tr>

             <tr><td>
                 <b>Glacial lake type</b>&nbsp;</td><td>
                 {this.props.stateInfo.glacial_type
                   .toLowerCase()
                   .split(" ")
                   .map((word) =>
                     word.replace(word[0], word[0].toUpperCase())
                   )
                   .join(" ")}
               </td></tr>
           
           </table>

         </div>
     
        
          <Button  style={{ marginLeft:"100px", cursor: 'pointer',borderColor:"black",fontSize:'14px',borderstyle:" 2px",borderstyle: "solid" }} onClick={this.props.closeInfo} >Close</Button>   
       </Message.Content>
     ) : (
    <b>  <Icon name="info" /> click on any glacial lake</b>
         )}
   </Message>
 </div>
) : (
   <Popup
     trigger={
       <Button
         size="tiny"
         compact
         style={{ padding: "0px" }}
         onClick={this.showInfo}
       >
         <FontAwesomeIcon icon="info-circle" size="m" />
       </Button>
     }
     position="right center"
   >
     <Popup.Content>
       click this to know about what is in the point you clicked in the
       map
   </Popup.Content>
   </Popup>
 )}
</div>
</OffCanvasMenu>
</OffCanvas>

</Control>
            )}

           
        <Marker
          position={
            this.state.latlng.lat && this.state.latlng.lng
              ? [this.state.latlng.lat, this.state.latlng.lng]
              : [0, 0]
          }
        />
        {/* {
                        this.state.layerloading?  <Control position='topleft'>
                                <div style={style}>

                            <FadeLoader
                                    height="15"
                                    radius='3'
                                    margin="3"
                                    width="10"
                                    
                                    // css={override}
                                    sizeUnit={"px"}
                                    // size={150}
                                    color={'#123abc'}
                                    loading={this.state.layerloading}
                                  />
                                      </div>

                        </Control>:null
                    } */}
        {/* <Control position='topleft'>
                    <Segment>
                        <Grid columns="equal" divided style={{marginLeft:"0rem", marginRight:"-3rem"}}>
                            <Grid.Row style={{paddingTop:"0em", paddingBottom:"0em"}}>
                                <Grid.Column>
                                <img src={under} alt="under construction"/>
                                    <Button basic size="tiny" floated="right" compact style={{padding:"5px"}} onClick={this.handlePopupClose}>
                                        <FontAwesomeIcon icon="window-close" size="lg"/>
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        
                        
                    </Segment>
                </Control> */}
        <Control position="topleft">
          <Popup
            trigger={
              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>

        </Control>
        {/* {
                      this.props.stateInfoStatus?  <Control position='topleft'>
                            <div style={style}>
                           <FadeLoader
                                    height="15"
                                    radius='3'
                                    margin="3"
                                    width="10"
                                    
                                    // css={override}
                                    sizeUnit={"px"}
                                    // size={150}
                                    color={'#123abc'}
                                    loading={this.props.stateInfoStatus}
                                  /></div>
                        </Control>:null
                    } */}

        {!this.props.visibleGraphPanel_pie && this.props.series !== null ? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel_pie}
                  secondary
                  style={{ backgroundColor: colors.graphical }}
                  compact
                  size="medium"
                >
                  <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null}

{!this.props.visibleGraphPanel_pie1 && this.props.series_gl_type !== null? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel_pie1}
                  secondary
                  style={{ backgroundColor: colors.graphical  }}
                  compact
                  size="medium"
                >
            <FontAwesomeIcon icon="chart-pie" size="lg"/>
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Pie Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null}





{/*
<Control position="bottomright">
  <h6>Glacial lakes type distribution</h6>

                <div>
                  

                  <PieChart  style={{
                  alignContent: "center",
                  backgroundColor: "rgb(255,255,255)",
                  borderColor: "blue",
                  top: "200px",
                  marginRight: "10px"}}/>
                </div>
              
                    
            
</Control>
                  */}






        {window.innerWidth > 1000 ?
          <Control position="topleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control> : <Control position="bottomleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>}

       
    
    
 






        
      </Map>

      //(this.state.latlng.lat && this.state.latlng.lng)?<div style={{height: "10%", width: "100%"}}>{this.state.latlng.lat}, {this.state.latlng.lng}</div>:null} }
    );
  }
}

export default GMapView;
